import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchBi = (payload) => {
  //console.log("payload", payload);
  return {
    type: actionTypes.FETCH_BENEFIT_ILLUSTRATION,
    formData: payload,
  };
};
// bi started
export const editBiStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_BENEFIT_ILLUSTRATION_START,
  };
};

export const editBISuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_BENEFIT_ILLUSTRATION_SUCCESS,
    formData: formData,
    succMsg: "BI Updated Successfully",
    response: res,
  };
};

export const fetchBISuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editBiStarted());
    axiosRequest
      .put(apiPath, payload)
      .then((res) => {
        //console.log(res);
        dispatch(fetchBi(res?.benefitIllustration));
      })
      .catch((err) => {
        //console.log(err)
      });
  };
};

export const editBIFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_BENEFIT_ILLUSTRATION_FAIL,
    error: errMsg,
  };
};
